import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({
  dataComponents: {
    drawer: { columns },
  },
}: ComposedTheme) => ({
  itemWrapper: {
    '&:hover, &:focus, &:focus-within': {
      backgroundColor: columns.itemHoverColor,
      '& $pinMove': {
        opacity: 1,
      },
    },
    '& > label': {
      margin: 0,
    },
    '& p': {
      fontFamily: columns.lockedColumn.font.fontFamily,
      fontSize: columns.lockedColumn.font.fontSize,
      fontWeight: columns.lockedColumn.font.fontWeight,
      color: columns.text.color,
      margin: 0,
    },
    touchAction: 'none',
    padding: 8,
    marginBottom: 5,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&$locked:hover': {
      backgroundColor: 'transparent',
    },
  },
  lockWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& > div': {
      position: 'relative',
      top: -2,
    },
    '& svg': {
      fill: columns.lockedColumn.lockIconColor,
    },
    '& p': {
      marginLeft: 8,
    },
  },
  pinMove: {
    display: 'flex',
    opacity: 0,
    alignItems: 'center',
    '& > p': {
      marginRight: 16,
    },
    '& button': {
      color: columns.pinButtonTextColor,
    },
  },
  spacer: {
    margin: [0, 12],
    color: columns.text.color,
  },
  locked: {
    '&:hover, &:focus': {
      backgroundColor: 'none',
    },
  },
  dragTrigger: {
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
    marginLeft: 16,
    '& svg': {
      fill: columns.dragIconColor,
    },
    '&:active': {
      cursor: 'grabbing',
    },
  },
});

export default createUseStyles(styles);
